import { render, staticRenderFns } from "./PreYearExam.vue?vue&type=template&id=17bb35c2&lang=pug&"
import script from "./PreYearExam.vue?vue&type=script&lang=js&"
export * from "./PreYearExam.vue?vue&type=script&lang=js&"
import style0 from "./PreYearExam.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports